import { createAction, props } from '@ngrx/store';

import type { SCEcmpAffiliateLogo } from './ecmp-logos.interface';

const ACTION_GROUP = '[ECMP Logos]';

export const setEcmpAffiliateLogo = createAction(
  `${ACTION_GROUP} Set ECMP Logo`,
  props<{ ecmpLogo: SCEcmpAffiliateLogo }>()
);
